<template>
  <div class="col-12 pt-3" v-if="show">
    <modal
      name="modal-profile-button"
      width="80%"
      height="auto"
      style="overflow-y: scroll"
    >
      <div class="vcard card">
        <div class=" card-head p-2 bg-primary text-center text-white">
          Zahlungs-Bestätigung
        </div>
        <div class="card-body pb-0 text-primary text-center">
          <div class="row">
            <div class="col-12 p-1 pb-4">
              {{ modalText }}
            </div>
          </div>
          <div class="row">
            <div class="col-6 p-1">
              <a
                @click="
                  $modal.hide('modal-profile-button');
                  buttonCallback();
                "
                class="btn btn-block btn-success text-white rounded"
                :class="{ disabled: disabled }"
              >
                Ok
              </a>
            </div>
            <div class="col-6 p-1">
              <a
                @click="$modal.hide('modal-profile-button')"
                class="btn btn-block btn-danger text-white rounded"
                :class="{ disabled: disabled }"
              >
                Nein
              </a>
            </div>
          </div>
        </div>
      </div>
    </modal>
    <div class="row">
      <div class="col-12 p-1">
        <v-button
          v-if="!this.areFriends && !this.friendRequestReceived"
          @click.native="paymentAlert($event)"
          class="btn btn-block text-white rounded"
          :class="{
            'btn-primary': !this.areFriends,
            'btn-warning': this.friendRequestSent
          }"
          :disabled="disableFriendButton"
          :working="sendingFriendRequest"
        >
          <span class="fas fa-user-friends"></span> {{ friendButtonText }}
        </v-button>
        <v-button
          v-else-if="this.friendRequestReceived"
          class="btn btn-block btn-success text-white rounded"
          @click.native="acceptFriendRequest"
        >
          <span class="fas fa-user-friends"></span> {{ friendButtonText }}
        </v-button>
        <v-button
          v-else
          :working="sendingFriendRequest"
          @click.native="handleFriendRequest"
          class="btn btn-block btn-danger text-white rounded"
        >
          <span class="fas fa-user-times"></span> {{ friendButtonText }}
        </v-button>
      </div>
      <div class="col-12 col-xl-6 p-1">
        <a
          @click="blinkAlert($event)"
          class="btn btn-block btn-danger text-white rounded"
          :class="{ disabled: disabled }"
          ><span class="far fa-smile-wink"></span> {{ blinkName }}
        </a>
      </div>
      <div class="col-12 col-xl-6 p-1">
        <a
          @click="checkAuth"
          :href="chatLink"
          class="btn btn-block btn-success text-white rounded"
          :class="{ disabled: disabled }"
        >
          <span class="far fa-envelope"></span>
          {{ messageText }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import FriendshipMixin from "@/components/Customer/mixins/Friendship";
import swal from "sweetalert2";

export default {
  mixins: [FriendshipMixin],
  props: {
    disabled: {
      required: true,
      type: Boolean
    },
    profile: {
      required: true,
      type: Object
    }
  },
  data: () => {
    return {
      modalText: "",
      buttonCallback: null,
      firstContact: false
    };
  },
  computed: {
    otherId() {
      return this.profile.id;
    },
    chatLink() {
      return `/chat?id=${this.profile.id}`;
    },
    blinkName() {
      return Laravel.settings.blinkName;
    },
    messageText() {
      if (!this.firstContact || this.firstMessagePrice == this.messagePrice) {
        return `Anschreiben`;
      }
      if (
        this.firstMessagePrice > 0 &&
        this.firstMessagePrice < this.messagePrice
      ) {
        return `Vergünstigt Anschreiben`;
      }
      return `Kostenlos Anschreiben`;
    },
    messagePrice() {
      return Laravel.settings.pricePerMessage;
    },
    firstMessagePrice() {
      return Laravel.settings.firstMessagePrice;
    },
    show() {
      if (!this.authCustomerProfile) {
        return true;
      }
      return this.authCustomerProfile.id !== this.profile.id;
    },
    disableFriendButton() {
      return this.disabled || this.areFriends || this.friendRequestSent;
    },
    friendButtonText() {
      if (this.areFriends) {
        return "Freundschaft beenden?";
      } else if (this.friendRequestSent) {
        return "Freundschaftsanfrage gesendet";
      } else if (this.friendRequestReceived) {
        return "Freundschaftsanfrage akzeptieren";
      } else {
        return "Freundschaftsanfrage senden";
      }
    }
  },
  methods: {
    acceptFriendRequest() {
      swal
        .fire({
          title: "Freundschaft akzeptieren?",
          text: `Möchtest du die Freundschaftsanfrage von ${this.profile.name} annehmen?`,
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#28a745",
          cancelButtonColor: "#d33",
          confirmButtonText: "Ja",
          cancelButtonText: "Nein"
        })
        .then(result => {
          if (result.value) {
            this.$http.post(`/api/v1/friends/${this.friendRequest.id}/accept`);
            window.location.reload();
          } else {
            this.$http.post(`/api/v1/friends/${this.friendRequest.id}/decline`);
            window.location.reload();
          }
        });
    },

    paymentAlert($event) {
      if (this.checkAuth($event)) {
        swal
          .fire({
            title: "Freundschaftsanfrage senden?",
            text:
              "Freundschaftsanfrage für " +
              Laravel.settings.pricePerFriendRequest +
              " " +
              Laravel.lang.currency +
              " senden? Wenn dein Chatpartner deine Anfrage bestätigt hat, sind alle Medien sichtbar.",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#28a745",
            cancelButtonColor: "#d33",
            confirmButtonText: "Ja",
            cancelButtonText: "Nein"
          })
          .then(result => {
            if (result.value) {
              this.sendFriendRequest();
            }
          });
      }
    },

    blinkAlert($event) {
      if (this.checkAuth($event)) {
        swal
          .fire({
            title: Laravel.settings.blinkName,
            text:
              Laravel.settings.blinkName +
              " für " +
              Laravel.settings.pricePerBlink +
              " " +
              Laravel.lang.currency,
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#28a745",
            cancelButtonColor: "#d33",
            confirmButtonText: "Ja",
            cancelButtonText: "Nein"
          })
          .then(result => {
            if (result.value) {
              this.blinkMessage();
            }
          });
      }
    },

    checkAuth(event) {
      if (!this.$store.getters["user/auth"]) {
        event.stopPropagation();
        event.preventDefault();

        this.$store.dispatch("publicProfileModal/show", this.$modal);

        return false;
      }

      return true;
    },

    blinkMessage(meta = null) {
      this.$store
        .dispatch("message/create", {
          url: "/api/v1/message",
          data: {
            body: " ",
            receiver_id: this.profile.id,
            sender_id: Laravel.user.customer_profile.id,
            type: 3,
            meta
          }
        })
        .catch(error => {
          this.$notify({
            title: error.response.data.message,
            type: "error"
          });
        });
    },

    sendFriendRequest() {
      this.sendingFriendRequest = true;
      this.$http
        .post("/api/v1/friends", {
          customer_profile_id1: this.authCustomerProfile.id,
          customer_profile_id2: this.otherId
        })
        .then(() => {
          location.reload();
        })
        .catch(error => {
          this.$notify({
            title: error.response.data,
            type: "error"
          });
        })
        .finally(() => {
          this.sendingFriendRequest = false;
        });
    },

    handleFriendRequest() {
      swal
        .fire({
          title: "Freundschaft beenden?",
          text: `Willst du wirklich die Freundschaft mit ${this.profile.name} beenden?`,
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#28a745",
          cancelButtonColor: "#d33",
          confirmButtonText: "Ja",
          cancelButtonText: "Nein"
        })
        .then(result => {
          if (result.value) {
            this.sendingFriendRequest = true;
            this.$http
              .delete(`/api/v1/friends/${this.friendRequest.id}`)
              .then(() => {
                location.reload();
              })
              .finally(() => {
                this.sendingFriendRequest = false;
              });
          }
        });
    }
  },
  created() {
    this.firstContact = true;
    if (this.authCustomerProfile) {
      this.$http
        .get("/api/v1/customerProfile/firstContact", {
          params: {
            customerProfileId: this.profile.id
          }
        })
        .then(({ data }) => {
          this.firstContact = data;
        });
    }
  }
};
</script>
